import { useSyncExternalStore } from "react";
import { useLocation } from "react-router-dom";
import { useAdminRole } from "@/hooks/useAdminRole";
import { isPracticeOn, subscribePractice } from "@/lib/practice/store";
import { practiceAllowed } from "@/lib/practice/scope";

/** Admin-only lesson/level preview, never active on real member pages. */
export function usePracticeMode(): boolean {
  const { data: isAdmin } = useAdminRole();
  const { pathname } = useLocation();
  const on = useSyncExternalStore(subscribePractice, () => isPracticeOn(pathname), () => false);
  return practiceAllowed(!!isAdmin, on, pathname);
}
